import React from "react";

// KpiCard: small label (uppercase by CSS) and number. `warn` uses the amber tokens and only applies when the
// value is greater than 0.
export default function KpiCard({ label, value, warn = false, title }) {
  const loaded = value !== null && value !== undefined;
  const isWarn = warn && loaded && Number(value) > 0;

  return (
    <div className={`crm-rollo__kpi${isWarn ? " crm-rollo__kpi--warn" : ""}`} title={title}>
      <span className="crm-rollo__kpi-label">{label}</span>
      {loaded ? (
        <span className="crm-rollo__kpi-value">{value}</span>
      ) : (
        <span className="crm-rollo__kpi-value" aria-hidden="true">
          <span className="crm-rollo__skel crm-rollo__skel--kpi" />
        </span>
      )}
    </div>
  );
}
